import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 20000,
});

export function resolveImage(url) {
  if (!url) return `${API}/static/generated/placeholder.png`;
  if (url.startsWith("http")) return url;
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  if (url.startsWith("/")) return `${BACKEND_URL}${url}`;
  return url;
}

export const mailto = (subject, email = "info@destoel.com") =>
  `mailto:${email}?subject=${encodeURIComponent(subject)}`;
